import React , { useState,useEffect }from 'react'
import Navbar from '../Components/Navbar'
import HeroSection from '../Components/HeroSection'
import Heading from '../Components/Heading'
import CardSection from '../Components/CardSection'
import InfoForm from '../Components/InfoForm'
import RentersPage from '../Components/RentersPage'
import OfficeTiming from '../Components/OfficeTimings'
import Location from '../Components/Location'
import Footer from '../Components/Footer'
import CustomerSer from '../Components/Customer'
import OnlineBooking from '../Components/OnlineBook'
/** just google search  */
<link rel="icon" href="public/favicon.ico"></link>

const HomePage = () => {
  const [showForm, setShowForm] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);

console.log(selectedOption)

 

    const handleStartQuote = (selected) => {
      if (selected === 'Personal Auto') {
          setShowForm(true);
          setSelectedOption('Personal Auto');
      }
      else if (selected === 'Business') {
        setSelectedOption('Business');
        
    }

    else if (selected === 'Renters') {
      setShowForm(true);
      setSelectedOption('Renters');
      
      
  }

  else if (selected === 'Comercial Auto') {
    
    setSelectedOption('Comercial Auto');
    
    
}

else if (selected === 'Surety Bond') {
    
  setSelectedOption('Surety Bond');
  
  
}

else if (selected === 'Life Insurance') {
    
  setSelectedOption('Life Insurance');
  
  
}
      
  };

  
   const handleRedirect = () => {
    window.location.href = 'https://app.coterieinsurance.com/quote?p=birimo.insurance%40gmail.com';
    };

    const handleComercialRedirect = () => {
      window.location.href = 'https://forms.office.com/r/NijMzrEiu8';
      };

      const handleSuretyRedirect = () => {
        window.location.href = 'https://birimoins.propeller.insure/axelerator-public';
        };

      const handleLifeInsuranceRedirect = () => {
        window.location.href = 'https://app.back9ins.com/apply/Life0001';
        };

    useEffect(() => {
      if (selectedOption === 'Business') {
          handleRedirect();}
          else if(selectedOption==='Comercial Auto'){
            handleComercialRedirect()
          }
          else if(selectedOption==='Surety Bond'){
            handleSuretyRedirect()
          }
          else if(selectedOption==='Life Insurance'){
            handleLifeInsuranceRedirect()
          }
  }, [selectedOption]);

  const resetForm = () => {
    setShowForm(false);
    setSelectedOption(null);
};
  


  return (
    <div>
    <Navbar onReset={resetForm}/>
    <HeroSection/>

    {!showForm && (
        <>
            <Heading/>
            <CardSection onStartQuote={handleStartQuote}/>
            <OnlineBooking/>
            <CustomerSer/>
           
            
            <OfficeTiming/>
            <Location/>
        </>
    )}

    {showForm && selectedOption === 'Personal Auto' && <InfoForm onReset={resetForm}/>}
    {showForm && selectedOption === 'Renters' && <RentersPage onReset={resetForm}/>}
<Footer/>
</div>
  )
}

export default HomePage
